import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Registration from "../components/Page/RegistrationPage/RegistrationPage";
import HomePage from "../components/Page/HomePage/HomePage";
import AuctionsPage from "../components/Page/AuctionsPage/AuctionsPage";
import FAQPage from "../components/Page/FAQPage/FAQPage";
import CartDetailsPage from "../components/Page/CartDetailsPage/CartDetailsPage";
import ProfilePage from "../components/Page/ProfilePage/ProfilePage";
import OrderList from "../components/Page/OrderListPage/OrderListPage";
import AuctionDetails from "../components/Page/AuctionDetails/AuctionDetails";
import Tokens from "../components/Page/Tokens/Tokens";
import InteractiveMap from "../components/Page/InteractiveMap/InteractiveMap";
import AdornAdore from "../components/Page/InteractiveMap/AdornAdore";
import BiriyaniBazaar from "../components/Page/InteractiveMap/BiriyaniBazaar";
import ChaatCorner from "../components/Page/InteractiveMap/ChaatCorner";
import CoffeeCorner from "../components/Page/InteractiveMap/CoffeeCorner";
import CookieCorner from "../components/Page/InteractiveMap/CookieCorner";
import CottonCandy from "../components/Page/InteractiveMap/CottonCandy";
import DazlingDesigns from "../components/Page/InteractiveMap/DazlingDesigns";
import DelightfulDrinks from "../components/Page/InteractiveMap/DelightfulDrinks";
import EthnicElegance from "../components/Page/InteractiveMap/EthnicElegance";
import GameBooth from "../components/Page/InteractiveMap/GameBooth";
import KidzKorner from "../components/Page/InteractiveMap/KidzKorner";
import ParottaKadai from "../components/Page/InteractiveMap/ParottaKadai";
import SnackShack from "../components/Page/InteractiveMap/SnackShack";
import BobaBites from "../components/Page/InteractiveMap/BobaBites";
import TiffinTable from "../components/Page/InteractiveMap/TiffinTable";
import MainPage from "../components/Page/MainPage/MainPage";
import ResonateExclusive from "../components/Page/ResonateExclusive/ResonateExclusive";
import ShopOnline from "../components/Page/ShopOnline/ShopOnline";
import Pledge from "../components/Page/Pledge/Pledge";
import MasalaMart from "../components/Page/InteractiveMap/MasalaMart";
import CrispyBites from "../components/Page/InteractiveMap/CrispyBites";
import Subscription from "../components/Page/Subscription/Subscription";
import ShareFeedback from "../components/Page/ShareFeedback/ShareFeedback"

const AppRouter = () => (
  <BrowserRouter>
    <Switch>
      <Route component={ShareFeedback} path="/" exact={true} />
      {/* <Route component={Registration} path="/registration" />
      <Route component={MainPage} path="/home" />
      <Route component={AuctionsPage} path="/auction" />
      <Route component={ResonateExclusive} path="/resonate-exclusives"/>
      <Route component={ShopOnline} path="/shop-online"/>
      <Route component={Subscription} path="/subscription" />
      <Route component={FAQPage} path="/faq" />
      <Route component={ShareFeedback} path="/feedback" />
      <Route component={ProfilePage} path="/profile" />
      <Route component={CartDetailsPage} path="/cart" />
      <Route component={OrderList} path="/orders" />
      <Route component={AuctionDetails} path="/auctiondetails/:auctionId" />
      <Route component={Tokens} path="/tokens" /> */}
    </Switch>
  </BrowserRouter>
);

export default AppRouter;
